import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/sections/Hero";
import Highlights from "../components/sections/Highlights";
import About from "../components/sections/About";
import Mission from "../components/sections/Mission";
import Programs from "../components/sections/Programs";
import GalleryPreview from "../components/sections/GalleryPreview";
import TestimonialsPreview from "../components/sections/TestimonialsPreview";
import CalendarPreview from "../components/sections/CalendarPreview";
import Admissions from "../components/sections/Admissions";
import Contact from "../components/sections/Contact";

const Home = () => {
  const location = useLocation();
  useEffect(() => {
    const id = location.state?.scrollTo;
    if (id) {
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 80);
    } else if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
    }
  }, [location]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Highlights />
      <About />
      <Mission />
      <Programs />
      <GalleryPreview />
      <TestimonialsPreview />
      <CalendarPreview />
      <Admissions />
      <Contact />
    </main>
  );
};

export default Home;
